import { gql } from '@apollo/client'
export const GET_LOCATION = gql`
  query GetLocation($locationId: String!) {
    getLocation(locationId: $locationId) {
      customerId
      locationId
      name
      devices {
        deviceId
        name
        deviceProperties
        lastUpd
        status
        screenshotUrl
        screenshotTimestamp
        statusReport {
          diskTotalGB
          avgLoad
          cpuLoad
          diskUsedGB
          temperature
          time
          totalMemMB
          usedMemMB
          uptimeMin
          hdmi1_rotation
          hdmi2_rotation
        }
        slideshowVersions {
          slideshowId
          level
        }
      }
    }
  }
`

export const GET_MEDIA_ITEMS = gql`
  query GetMediaItems(
    $customerId: String!
    $locationId: String
    $types: [MediaType]
  ) {
    getMediaItems(
      customerId: $customerId
      locationId: $locationId
      types: $types
    ) {
      url
      mediaItemId
      width
      height
      previewURL
      type
      lastUpd
      tags
      createdByUser {
        userName
        role
        customerId
      }
    }
  }
`
export const GET_SLIDES = gql`
  query GetSlides($customerId: String!, $locationId: String) {
    getSlides(customerId: $customerId, locationId: $locationId) {
      slideId
      previewURL
      layout
      type
      lastUpd
      tags
      createdByUser {
        userName
        role
        customerId
      }
      # layout
      # data
      # elements {
      #   mediaItemId
      # }
    }
  }
`

export const GET_EVENTS = gql`
  query GetEvents {
    getEvents {
      id
      startTime
      home {
        displayName
        shortName
        logo
        name
      }
      away {
        displayName
        shortName
        logo
        name
      }
    }
  }
`

export const GET_MEDIA_ITEM = gql`
  query GetMediaItem($mediaItemId: String!) {
    getMediaItem(mediaItemId: $mediaItemId) {
      mediaItemId
      type
      lastUpd
      url
      previewURL
      tags
    }
  }
`
export const GET_SLIDE = gql`
  query GetSlide($slideId: String!) {
    getSlide(slideId: $slideId) {
      slideId
      data
      type
      layout
      lastUpd
      tags
      createdByUser {
        userName
        role
        customerId
      }
      elements {
        mediaItemId
        url
        previewURL
        type
      }
    }
  }
`

export const GET_CUSTOMERS = gql`
  query GetCustomers {
    getCustomers {
      customerId
      name
      locations {
        devices {
          deviceId
        }
        name
        locationId
      }
      detachedDevices {
        deviceId
        lastUpd
        name
      }
    }
  }
`
export const GET_LOCATION_METRICS = gql`
  query GetLocationMetrics(
    $locationId: String!
    $startTime: String
    $endTime: String
    $unit: TimeUnit
  ) {
    getLocation(locationId: $locationId) {
      metrics(startTime: $startTime, endTime: $endTime, unit: $unit) {
        liveData {
          timestamp
          locationId
          activeDevices
          fromRoundedTimestamp
          toRoundedTimestamp
        }
        locationData {
          timestamp
          locationId
          activeDevices
          fromRoundedTimestamp
          toRoundedTimestamp
        }
      }
    }
  }
`

export const GET_GAMES_BY_DATES = gql`
  query GetEvents($startDate: String, $endDate: String) {
    getEvents(startDate: $startDate, endDate: $endDate) {
      id
      name
      home {
        displayName
        logo
        name
      }
      away {
        displayName
        logo
        name
      }
      startTime
      status
      leagueId
      sportId
      closed
    }
  }
`

export const GET_DEVICES_LIVE = gql`
  query GetDevicesLive {
    getDevicesLive {
      deviceId
      deviceName
      locationId
      locationName
      activeDevices
      lastTimeConnected
      lastTimeActiveDevices
      statusReport {
        diskTotalGB
        diskUsedGB
        temperature
        time
        totalMemMB
        usedMemMB
        uptimeMin
        hdmi1_rotation
        hdmi2_rotation
      }
    }
  }
`

export const GET_SLIDESHOWS_BY_CUSTOMER = gql`
  query GetSlideshowsByCustomer(
    $customerId: String!
    $locationId: String
    $level: SlideshowLevel!
  ) {
    getSlideshows(
      customerId: $customerId
      locationId: $locationId
      level: $level
    ) {
      slideshowId
      name
      level
      lastUpd
      locationIds
      aspectRatio
      slides {
        slideId
        data
        type
        layout
        previewURL
        lastUpd
        elements {
          mediaItemId
        }
      }
      schedules {
        id
        name
        dateTime
        deviceIds
        locationIds
        lastUpd
        processed
        slideshowId
      }
    }
  }
`

export const GET_LOCATION_PREVIEW_METRICS = gql`
  query GetLocationPreviewMetrics(
    $locationId: String!
    $startTime: String
    $endTime: String
    $unit: TimeUnit
  ) {
    getLocation(locationId: $locationId) {
      metrics(startTime: $startTime, endTime: $endTime, unit: $unit) {
        liveData {
          activeDevices
          timestamp
        }
        locationData {
          timestamp
          locationId
          activeDevices
          fromRoundedTimestamp
          toRoundedTimestamp
        }
      }
    }
  }
`

export const GET_USERS = gql`
  query GetUsers($customerId: String) {
    getUsers(customerId: $customerId) {
      userName
      role
      customerId
      customer {
        customerId
        name
      }
      locations {
        locationId
        name
      }
    }
  }
`

export const GET_LOCATION_DEVICE_METRICS = gql`
  query GetLocationDeviceMetrics(
    $locationId: String!
    $startTime: String
    $endTime: String
    $unit: TimeUnit
  ) {
    getLocationDeviceMetrics(
      locationId: $locationId
      startTime: $startTime
      endTime: $endTime
      unit: $unit
    ) {
      locationId
      deviceData {
        deviceId
        locationId
        activeDevices
        timestamp
        fromRoundedTimestamp
        toRoundedTimestamp
      }
    }
  }
`
